<label *ngIf="label != null && label != '' && showLabel" class="sumax-label mb-0 p-0">{{label}}<span *ngIf="required"
    [class.text-danger]="controls?.errors != null"> *</span></label>

<div [class.input-icon]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
[class.refresh]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted && refresh"
[class.right]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted">

  <!-- tooltip-message es el icono de error -->
  <tooltip-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage" [submitted]="submitted"
    [tooltipMessage]="tooltipMessage"></tooltip-message>
<div class="d-flex">
  <div class="w-100">
  <ng-select #ngSelectMultiple [items]="$any((checkIfObservable(items)) ? (items | async) : (items))" [(ngModel)]="_value"
    [readonly]="disabled || readonly" (change)="eventChange($event)" (focus)="eventFocus($event)"
    (blur)="eventBlur($event)" [virtualScroll]="true" [multiple]="true" placeholder="Seleccionar"
    [closeOnSelect]="false" [appendTo]="appendTo" [inputAttrs]="{'autocomplete': autocomplete}" [markFirst]="markFirst"
    (keyup.ArrowLeft)="leftKeyUp()" (keyup.ArrowRight)="rightKeyUp()" [loading]="loading" [loadingText]="loadingText"
    [class.ng-select-invalid]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
    [class.ng-select-touched]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted">

    <ng-template ng-header-tmp *ngIf="Header">
      <mat-checkbox class="ng-multiselect-checkbox" [color]="'primary'" [(ngModel)]="checkedAll"
        [indeterminate]="checkedIndeterminate" (change)="selectAll($event)">
        <span *ngIf="!checkedAll">{{Language.SelectAll}}</span>
        <span *ngIf="checkedAll">{{Language.UnselectAll}}</span>
      </mat-checkbox>
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear"
    *ngIf="$any((checkIfObservable(items)) ? (items | async) : (items))?.length != _value.length">
      <div class="ng-value" *ngFor="let item of items | slice:0:showlimit">
        <span class="ng-value-label"> {{$any(item).label}}</span>
        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
      </div>
      <div class="ng-value" *ngIf="items.length > showlimit">
        <span class="ng-value-label">+{{items.length - showlimit}}</span>
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">

      <mat-checkbox class="ng-multiselect-checkbox" id="item-{{index}}" color="primary" [checked]="item$.selected"
        (click)="false"> <span data-toggle="tooltip" title="{{item.label}}">{{ item.label }}</span>
      </mat-checkbox>
    </ng-template>


    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear"
    *ngIf="$any((checkIfObservable(items)) ? (items | async) : (items))?.length == _value.length">
      <div class="ng-value">
        <span class="ng-value-label">{{Language.All}}</span>
      </div>
    </ng-template>

    <ng-template ng-footer-tmp *ngIf="Footer">
      {{Language.Selected}}: {{_value.length}}
    </ng-template>

  </ng-select>
  </div>
  <div class="bd-highlight" *ngIf="refresh">
    <button *ngIf="refresh" type="button" [disabled]="disabled || readonly" class="btn btn-info p-0 rounded-0 h-100"
      (click)="onRefresh()">
      <!-- <mat-icon class="text-white pt-1" style="font-size: 18px;" [matTooltip]="'Refrescar'" matTooltipClass="bg-info">refresh</mat-icon> -->
      <i class="la la-refresh text-white px-1" [matTooltip]="'Refrescar'" matTooltipClass="bg-info"></i>
    </button>
  </div>
</div>

</div>

<!-- error-message es el mansaje que aparece abajo del componente -->
<error-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage"
  [tooltipMessage]="tooltipMessage" [submitted]="submitted"></error-message>